import { app } from '../../../bootstrap/core';
import { uiSrefIf } from './ui-sref-if.directive';

app.directive('uiSrefIf', uiSrefIf);
